import { Injectable } from '@angular/core';
import { ComponentItem } from '../../../classes/component-item';

import { ClientStatsEnrollmentsComponent } from '../../components/client-stats-enrollments/client-stats-enrollments.component';
import { ClientStatsClickthroughsComponent } from '../../components/client-stats-clickthroughs/client-stats-clickthroughs.component';
import { ClientStatsPrefChangesComponent } from '../../components/client-stats-pref-changes/client-stats-pref-changes.component';
import { ClientStatsIncompleteEnrollmentsComponent } from '../../components/client-stats-incomplete-enrollments/client-stats-incomplete-enrollments.component';

@Injectable({
  providedIn: 'root'
})
export class ClientStatsSectionFactoryService {

  constructor() { }

  public getComponentSection(sectionTypeName: string): ComponentItem {
    let componentItem!: ComponentItem;
    switch(sectionTypeName) {
      case "enrollments":
        componentItem = new ComponentItem(ClientStatsEnrollmentsComponent);
        break;
      case "unenrollments":
        break;
      case "notifications":
        break;
      case "pref-changes":
        componentItem = new ComponentItem(ClientStatsPrefChangesComponent);
        break;
      case "clickthroughs":
        componentItem = new ComponentItem(ClientStatsClickthroughsComponent);
        break;
      case "incomplete-enrollments":
        componentItem = new ComponentItem(ClientStatsIncompleteEnrollmentsComponent);
        break;
      case "incomplete-attempts":
        break;
      }
    return componentItem;
  }

  
}
